import { FC } from 'react'
import { useAuth } from 'react-oidc-context'
import { Link, useLocation } from 'react-router-dom'
import { useSession } from '../../../hooks/storeHooks/useSessionState'

export interface IToastContentProps {
  remainingTime: string
  advice: string
}
interface IRemainingToastLayoutProps {
  data: IToastContentProps
}

export const RemainingToastLayout: FC<IRemainingToastLayoutProps> = ({
  data,
}) => {
  const location = useLocation()
  const { isAuthenticated, signinRedirect } = useAuth()
  const { personaData } = useSession()

  const handleCreateAccount = async () => {
    await signinRedirect({
      state: { returnUrl: `${location.pathname}${location.search}` },
      extraQueryParams: {
        action: 'get-started',
        backgroundUrl: personaData?.videoLoopUrl || '',
      },
    })
  }

  return (
    <div className="flex justify-between items-center gap-2 flex-col min-[480px]:flex-row">
      <p className="text-sm">
        <b>{data.remainingTime}</b>
        <span className="min-[480px]:inline hidden">
          {` remaining - ${data.advice}`}
        </span>
      </p>
      {isAuthenticated ? (
        <Link
          to="/pricing"
          className="btn btn-secondary btn-small"
          data-testid="toast-buy-minutes-button"
        >
          Buy minutes
        </Link>
      ) : (
        <button
          className="btn btn-secondary btn-small"
          onClick={handleCreateAccount}
          data-testid="toast-signup-button"
        >
          Sign up
        </button>
      )}
    </div>
  )
}
